<template>
    <div class="category">
        <div class="dropdown">
            <div class="[ align-items-center d-flex ] [ ui dropdown ] dropdown-toggle" id="dropdowncategory" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="icon-custom-burger-menu big-lg medium color theme"></i>
                <span class="[ ml-lg-3 ml-2 ] [ ui header small-xl extra-mini m-0 light color black ]" >{{$t('Categories')}}</span>
                <div class="menu dropdown-menu" aria-labelledby="dropdowncategory">
                    <div v-for="(category,i) in categorys" 
                    :key=" 'category'+i "
                    @click="goToRoute($event)"
                    class="item categoryitem"
                    :categoryId="category.id"
                    :name ="category.name">
                        <span class="categoryitem"
                            :categoryId="category.id"
                            :name ="category.name">
                            {{category.name}} {{(category.amount > 0 ? '(' + category.amount + ')' : '')}}
                            <div v-if="category.childrens.length > 0" class="menu">
                                <div @click="goToRoute($event)"
                                    v-for="(subCategory,ii) in category.childrens" :key=" 'subCategory'+ ii " class="item"
                                    :subCategoryId="subCategory.id"
                                    :name ="subCategory.name">
                                    {{subCategory.name}}
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'category',
    props:{
        categorys: {
            type: Array,
            default: () => []
        },
        categoryId: Number,
        subCategoryId: Number,
        search: String
    },
    data(){
        return {
        }
    },
    methods: {
        goToRoute(event){
            var path = '/products?'
            this.$parent.search = event.target.getAttribute('name')
            this.$router.push({
                name: 'product', 
                query: {
                    search: this.$parent.search
                }
            })
        }
    },
}
</script>
<style lang="scss">
.router-link-active {
    color: #000!important;
}
.icon-custom-burger-menu.big-lg.medium{
    font-size: 1rem!important;
}
</style>
